import CakeRisksComponent from './CakeRisks/CakeRisks'

export const CakeRisks = CakeRisksComponent
